module.exports = __webpack_public_path__ + "static/media/VKFest_main_preview.71c49cdf.jpg";